import { render, staticRenderFns } from "./status-form.vue?vue&type=template&id=1d2f55cd&scoped=true"
import script from "./status-form.vue?vue&type=script&lang=js"
export * from "./status-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f55cd",
  null
  
)

export default component.exports